// @flow
/* eslint-disable max-len,react/require-default-props */

import * as React from 'react';
import { SvgXml } from 'react-native-svg';
import {
    Platform,
} from 'react-native';

const styles = {
    first: {
        fill: 'none',
        stroke: '#0080b4',
        strokeLinejoin: 'round',
        strokeWidth: 1.5,
    },
    second: {
        fill: 'none',
        stroke: '#0080b4',
        strokeLinecap: 'round',
        strokeMiterlimit: 10,
        strokeWidth: 1.00959492614297,
    },
    third: {
        fill: 'none',
        stroke: '#0080b4',
        strokeMiterlimit: 10,
    },
    fourth: {
        fill: 'none',
        stroke: '#0080b4',
        strokeLinecap: 'round',
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
    },
};

const xml = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.95 26.46" width={25} height={25}>
            <title>delete</title>
            <g id="Layer_2">
                <g id="Layer_1-2">
                    <path d="M.75,8.14H17.2a0,0,0,0,1,0,0V22.6a3.1,3.1,0,0,1-3.1,3.1H3.85a3.1,3.1,0,0,1-3.1-3.1V8.14A0,0,0,0,1,.75,8.14Z" style={styles.first} />
                    <line x1="4.86" y1="12.34" x2="4.86" y2="22.32" style={styles.second} />
                    <line x1="8.97" y1="12.34" x2="8.97" y2="22.32" style={styles.second} />
                    <line x1="13.09" y1="12.34" x2="13.09" y2="22.32" style={styles.second} />
                    <path d="M12,4.2,6.38,2.85,6.7,1.53a1.37,1.37,0,0,1,1.66-1l3,.72a1.34,1.34,0,0,1,1,1.63Z" style={styles.third} />
                    <line x1="1.22" y1="1.61" x2="17.2" y2="5.44" style={styles.fourth} />
                </g>
            </g>
        </svg>
`;

const DeleteIcon = () => (
    Platform.OS === 'web' ? (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.95 26.46" width={25} height={25}>
            <title>delete</title>
            <g id="Layer_2">
                <g id="Layer_1-2">
                    <path d="M.75,8.14H17.2a0,0,0,0,1,0,0V22.6a3.1,3.1,0,0,1-3.1,3.1H3.85a3.1,3.1,0,0,1-3.1-3.1V8.14A0,0,0,0,1,.75,8.14Z" style={styles.first} />
                    <line x1="4.86" y1="12.34" x2="4.86" y2="22.32" style={styles.second} />
                    <line x1="8.97" y1="12.34" x2="8.97" y2="22.32" style={styles.second} />
                    <line x1="13.09" y1="12.34" x2="13.09" y2="22.32" style={styles.second} />
                    <path d="M12,4.2,6.38,2.85,6.7,1.53a1.37,1.37,0,0,1,1.66-1l3,.72a1.34,1.34,0,0,1,1,1.63Z" style={styles.third} />
                    <line x1="1.22" y1="1.61" x2="17.2" y2="5.44" style={styles.fourth} />
                </g>
            </g>
        </svg>
    ) : (<SvgXml xml={xml} />)
);

export default DeleteIcon;
